module.exports = __webpack_public_path__ + "img/topo_login_mobile.bf5e2e4c.png";